module.exports = __webpack_public_path__ + "static/media/close.cc3091c7.svg";